import Colors, { withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
const StepNavigationTheme = {
    stepNavigation: {
        light: {
            lineBackgroundColor: withOpacity(Colors.black, Opacities.xLow),
            activeLineColor: Colors.accessibleSafetyOrange,
            totalStepsColor: withOpacity(Colors.black, Opacities.low),
            states: {
                focused: {
                    lineColor: Colors.accessibleSafetyOrange,
                    textColor: Colors.black,
                },
                completed: {
                    lineColor: Colors.accessibleSafetyOrange,
                    textColor: Colors.black,
                },
                completedHover: {
                    lineColor: Colors.black,
                    textColor: withOpacity(Colors.black, Opacities.medium),
                },
                upcoming: {
                    lineColor: withOpacity(Colors.black, Opacities.xLow),
                    textColor: withOpacity(Colors.black, Opacities.low),
                },
                disabled: {
                    lineColor: Colors.black,
                    textColor: withOpacity(Colors.black, Opacities.low),
                },
                draft: {
                    lineColor: withOpacity(Colors.black, Opacities.medium),
                    textColor: withOpacity(Colors.black, Opacities.medium),
                },
                draftHover: {
                    lineColor: withOpacity(Colors.black, Opacities.medium),
                    textColor: Colors.black,
                },
            },
        },
        dark: {
            lineBackgroundColor: withOpacity(Colors.white, Opacities.xLow),
            totalStepsColor: withOpacity(Colors.white, Opacities.low),
            states: {
                focused: {
                    lineColor: Colors.accessibleSafetyOrange,
                    textColor: Colors.white,
                },
                completed: {
                    lineColor: Colors.accessibleSafetyOrange,
                    textColor: Colors.white,
                },
                completedHover: {
                    lineColor: Colors.accessibleSafetyOrange,
                    textColor: withOpacity(Colors.white, Opacities.medium),
                },
                upcoming: {
                    lineColor: withOpacity(Colors.white, Opacities.xLow),
                    textColor: withOpacity(Colors.white, Opacities.low),
                },
                disabled: {
                    lineColor: Colors.white,
                    textColor: withOpacity(Colors.white, Opacities.low),
                },
                draft: {
                    lineColor: Colors.white,
                    textColor: withOpacity(Colors.white, Opacities.medium),
                },
                draftHover: {
                    lineColor: withOpacity(Colors.white, Opacities.medium),
                    textColor: Colors.white,
                },
            },
        },
    },
};
export default StepNavigationTheme;
